import { Button, useComputed } from "@homebound/beam";
import { useNavigate } from "react-router-dom";
import { StepActions, useStepperContext } from "src/components/stepper";
import { GuidedChangeEventFormState } from "src/routes/projects/change-events/guided/CreateGuidedChangeEventPage";
import { createChangeEventsUrl } from "src/RouteUrls";

type GuidedChangeEventStepActionsProps = { formState: GuidedChangeEventFormState; projectId: string };

/**
 * Actions for the guided change event wizard, rendered into the stepper's bottom bar via `StepActions`.
 */
export function GuidedChangeEventStepActions(props: GuidedChangeEventStepActionsProps) {
  const { formState, projectId } = props;
  const { prevStep, nextStep, isFirstStep, isLastStep, steps, currentStep } = useStepperContext();
  const navigate = useNavigate();
  const isValid = useComputed(() => formState.valid, [formState]);
  const currentStepIndex = steps.findIndex((step) => step.value === currentStep.value);
  const nextStepDisabled = steps[currentStepIndex + 1]?.disabled;

  return (
    <StepActions>
      <>
        {!isFirstStep && <Button variant="tertiary" label="Back" size="lg" onClick={prevStep} />}
        <Button
          variant="secondary"
          label="Cancel"
          size="lg"
          onClick={() => navigate(createChangeEventsUrl(projectId))}
        />
        {isLastStep ? (
          // TODO: submit the change event
          <Button label="Create Change Event" size="lg" disabled={!isValid} onClick={() => {}} />
        ) : (
          <Button label="Next" size="lg" disabled={nextStepDisabled} onClick={nextStep} />
        )}
      </>
    </StepActions>
  );
}
